<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--down" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="m20 9-7.5 8L5 9" stroke="currentColor"/></svg>
</template>